import { useMemo, useState } from 'react';
import { TransferReservationState } from '../models/TransferReservationState';
import { NewTable, NewTableColumn } from 'shared/components/NewTable';

interface Props {
  reservationStates: TransferReservationState[];
}

const ROWS_PER_PAGE_OPTIONS = [5, 10, 25];

export const ViajeTrasladoStatesTable = ({ reservationStates }: Props) => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const columns = useMemo<NewTableColumn<TransferReservationState>[]>(
    () => [
      {
        key: 'type',
        label: 'Estado',
        width: '20%',
        render: (row) => (
          <span className="text-ink dark:text-ink-dark">{row.type}</span>
        )
      },
      {
        key: 'datetime',
        label: 'Fecha',
        width: '20%',
        render: (row) => (
          <span className="text-ink dark:text-ink-dark">
            {row.datetime.format('DD/MM/YYYY HH:mm')}
          </span>
        )
      },
      {
        key: 'user',
        label: 'Usuario',
        width: '20%',
        render: (row) => (
          <span className="text-ink dark:text-ink-dark">{row.user?.name}</span>
        )
      },
      {
        key: 'observation',
        label: 'Observación cliente',
        width: '20%',
        render: (row) => (
          <span className="text-ink dark:text-ink-dark">{row.observation}</span>
        )
      },
      {
        key: 'observation_internal',
        label: 'Observación interna',
        width: '20%',
        render: (row) => (
          <span className="text-ink dark:text-ink-dark">
            {row.observation_internal}
          </span>
        )
      }
    ],
    []
  );

  const paginatedStates = useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    return reservationStates.slice(start, start + rowsPerPage);
  }, [reservationStates, page, rowsPerPage]);

  return (
    <NewTable
      columns={columns}
      data={paginatedStates}
      getRowKey={(row) => `${row.datetime.valueOf()}-${row.type}`}
      page={page}
      rowsPerPage={rowsPerPage}
      total={reservationStates.length}
      onChangePage={setPage}
      onChangeRowsPerPage={(value) => {
        setRowsPerPage(value);
        setPage(1);
      }}
      rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
      emptyTitle="No hay estados registrados"
    />
  );
};
